/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable  
*/
import React from "react";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { db } from "../../utils/firebase";
import { useAuth } from "../../contexts/AuthContext";
import {
  collection,
  getDocs,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

const budgetPageContent = () => {
  const [categoryAmount, setCategoryAmount] = useState(null);
  const { currentUser } = useAuth();
  let [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1); // getMonth is 0-based
  const budgetsCollectionRef = query(
    collection(db, `budgets/${currentUser.auth.currentUser.uid}/budgetDocs`)
  );
  const transactionsCollectionRef = query(
    collection(db, "transactions"),
    where("uId", "==", currentUser.auth.currentUser.uid),
    orderBy("date", "desc")
  );
  let [transactions, setTransactions] = useState([]);
  const [budgets, setBudgets] = useState([]);
  let [tmpBudgets, setTmpBudgets] = useState([]);

  let [cat, setCat] = useState([
    "Donation",
    "Education",
    "Entertainment",
    "Groceries",
    "Housing",
    "Medical",
    "Pets",
    "Reimbursement",
    "Restaurant",
    "Technology",
    "Utilities",
    "Vacation",
    "Work",
    "Other Expense",
  ]);

  const [onPageLoad, setOnPageLoad] = useState(false);

  let newArray = Array.apply(0, Array(16));
  let newArray2 = Array.apply(0, Array(16));
  let transT = Array.apply(null, Array(100));

  const getTransactions = async () => {
    const data = await getDocs(transactionsCollectionRef);
    //console.log(JSON.stringify(data.docs, null, 2)); //...doc.data(), id: doc.id
    transT = data.docs.map((doc) => ({ ...doc.data(), uId: doc.id }));
    setTransactions(transT);
    return transT;
  };

  const getCats = async () => {
    let cats = Array.apply("\n", Array(14));
    cats[0] = "Donation";
    cats[1] = "Education";
    cats[2] = "Entertainment";
    cats[3] = "Groceries";
    cats[4] = "Housing";
    cats[5] = "Medical";
    cats[6] = "Pets";
    cats[7] = "Reimbursement";
    cats[8] = "Restaurant";
    cats[9] = "Technology";
    cats[10] = "Utilities";
    cats[11] = "Vacation";
    cats[12] = "Work";
    cats[13] = "Other Expense";
    setCat(cats);
  };

  const getBudgets = async (transData) => {
    let newObj = null;

    const data = await getDocs(budgetsCollectionRef);
    const dataReal = data.docs.map((doc) => ({
      ...doc.data(),
      uId: doc.id,
      budgetDocs: doc.data().budgetDocs,
    }));
    console.log("DATA REAL");
    console.log(dataReal);
    var budgetForMonthYear = dataReal.filter(
      (bud) => bud.uId == new Date().getFullYear() + currentMonth.toString()
    );
    // console.log(budgetForMonthYear);
    var budgetObj = {};
    let tableRow = [];
    cat.forEach((category) => {
      if (
        budgetForMonthYear.length == 0 ||
        budgetForMonthYear[0][category] == undefined
      ) {
        budgetObj[category] = 0;
        // console.log(category, budgetForMonthYear[0][category]);
        tableRow.push({
          month: currentMonth,
          year: new Date().getFullYear(),
          category: String(category),
          spent: 0.0,
          amount: 0,
          uId: currentUser.auth.currentUser.uid,
        });
      } else {
        budgetObj[category] = budgetForMonthYear[0][category];
        // console.log("Not: " + category + " " + budgetForMonthYear[0][category]);
        tableRow.push({
          month: currentMonth,
          year: new Date().getFullYear(),
          category: String(category),
          spent: 0.0,
          amount: budgetForMonthYear[0][category],
          uId: currentUser.auth.currentUser.uid,
        });
      }
    });

    // console.log(budgetObj);
    // console.log(Object.keys(budgetObj).length);
    // console.log(tableRow);
    setCategoryAmount(budgetObj);

    tableRow.forEach((budgetObj) => {
      // console.log(budgetObj);
      //filter transactions by category, month, and current year
      // console.log(transData);
      let transByCat = transData.filter(
        (trans) =>
          trans.category === budgetObj.category &&
          trans.date.split("-")[1] == currentMonth &&
          trans.date.split("-")[0] == new Date().getFullYear()
      ); // 1

      let totalSum = 0;
      for (var numTrans = 0; numTrans < transByCat.length; numTrans++) {
        totalSum += parseFloat(transByCat[numTrans].amount); // 2
      }

      budgetObj["spent"] = totalSum.toFixed(2); // 3
    });
    // console.log("Table Row");
    // console.log(tableRow);
    getTmpBudgets(tableRow.map((doc) => ({ ...doc, uId: doc.id })));
    setOnPageLoad(true);
  };

  function calTmpBudgets() {
    let dataB = budgets; //dataB2;
    let dataT = transactions; //dataT2;

    let tmp = [];

    for (let i = 0; i < 14; i++) {
      tmp.push({
        month: currentMonth,
        year: new Date().getFullYear(),
        category: String(cat[i]),
        spent: 0.0,
        amount: dataB[i],
        uId: currentUser.auth.currentUser.uid,
      });

      //console.log(dataB[i]);
    }
    if (dataB) {
      //REDO THIS part
      console.log(dataB);
      for (let i = 0; i < 14; i++) {
        if (dataB[i] > 0) {
          tmp[i].amount = parseFloat(dataB[i]);
        }
      } //end for

      /******************************************************************** */
      //EUGENE ORIGINAL
      /******************************************************************** */
      // for (let i = 0; i < tmp.length; i++) {
      //   for (let j = 0; j < dataT.length; j++) {
      //     if (dataT[j].amount > 0) {
      //       tmp[i].spent =
      //         parseFloat(tmp[j].spent) + parseFloat(dataT[j].amount);
      //       console.log("what " + tmp[i].spent);
      //       break;
      //     }
      //   }
      // }
      // //tmpBudgets = tmp.map((doc) => ({ ...doc, uId: doc.id }));

      /******************************************************************** */
      //ESTHER MODIFICATION
      // 1 - for each category, filter out the transactions for the specific category
      // 2 - get the sum of the transactions by category (transByCat)
      // 3 - set the spent amount
      /******************************************************************** */
      // console.log(tmp);
      // console.log(dataT);

      tmp.forEach((budgetObj) => {
        // console.log(budgetObj);
        //filter transactions by category, month, and current year
        let transByCat = dataT.filter(
          (trans) =>
            trans.category === budgetObj.category &&
            trans.date.split("-")[1] == currentMonth &&
            trans.date.split("-")[0] == new Date().getFullYear()
        ); // 1
        // console.log(transByCat);

        let totalSum = 0;
        for (var numTrans = 0; numTrans < transByCat.length; numTrans++) {
          totalSum += parseFloat(transByCat[numTrans].amount); // 2
        }

        budgetObj["spent"] = totalSum.toFixed(2); // 3
      });

      getTmpBudgets(tmp.map((doc) => ({ ...doc, uId: doc.id })));
      setOnPageLoad(true);
    }
  }

  const getTmpBudgets = async (value) => {
    setTmpBudgets(value);
  };

  const handleChange = () => {
    getBudgets().then(() => {
      calTmpBudgets();
    });
  };

  useEffect(() => {
    getTransactions().then((data) => {
      getBudgets(data).then(() => {});
    });
    //getTmpBudgets(budgets, transactions);
  }, [currentMonth]);

  return (
    <>
      <div className="bodyContent">
        <div className="row">
          <div className="col-md-6 text-left">
            <h1>Budgets</h1>
            <p><em>Compare your spending with your budgets.</em></p>
          </div>
          {/*dropdown menu linked to data value currentMonth variable as well as updating the table when selected*/}
          <div>
            <label id="dropdownMenuButton" data-bs-toggle="dropdown">
              <select
                className="btn btn-secondary dropdown-toggle"
                id="dropdownMenuButton"
                defaultValue={currentMonth}
                onLoadStart={onPageLoad === false ? calTmpBudgets() : null}
                onChange={(e) =>
                  setCurrentMonth(e.target.value) && handleChange()
                }
              >
                <option value="01" id="January">
                  January
                </option>
                <option value="02" id="Feburary">
                  February
                </option>
                <option value="03" id="March">
                  March
                </option>
                <option value="04" id="April">
                  April
                </option>
                <option value="05" id="May">
                  May
                </option>
                <option value="06" id="June">
                  June
                </option>
                <option value="07" id="July">
                  July
                </option>
                <option value="08" id="August">
                  August
                </option>
                <option value="09" id="September">
                  September
                </option>
                <option value="10" id="October">
                  October
                </option>
                <option value="11" id="November">
                  November
                </option>
                <option value="12" id="December">
                  December
                </option>
              </select>
            </label>

            <div className=" btn col-md-8 text-center">
              <Link to="/budget/add" className="btn btn-success">
                Set Category Budget
              </Link>
            </div>
          </div>
        </div>
        <Table className="table" striped bordered hover>
          <thead>
            <tr className="header">
              <th>
                <span>
                  Month-Year <i className="fa fa-sort"></i>
                </span>
              </th>
              <th>
                <span>
                  Category <i className="fa fa-sort"></i>
                </span>
              </th>
              <th>
                <span>
                  Spent <i className="fa fa-sort"></i>
                </span>
              </th>
              <th>
                <span>
                  Budget Amount <i className="fa fa-sort"></i>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {tmpBudgets ? (
              tmpBudgets.map((budget, index) => (
                <tr key={index}>
                  <td>
                    {budget.month} - {budget.year}
                  </td>
                  <td>{budget.category}</td>
                  <td>
                    <span
                      className={
                        parseFloat(budget.spent) > parseFloat(budget.amount)
                          ? "overAmount"
                          : "lowerAmount"
                      }
                    >
                      ${parseFloat(budget.spent).toFixed(2)}
                    </span>
                  </td>
                  <td>${parseFloat(budget.amount).toFixed(2)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No budgets</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default budgetPageContent;
